<template>
  <div id="app">
    <div id="background" class="fixed bg-contain md:bg-contain">
    </div>
    <div id="nav" class="fixed z-50 w-full bg-transparent h-10 right-0 top-0 
    md:w-1/2 left-1/2">
      <div class="h-full relative flex justify-center flex-row">
        <router-link to="/work">Work</router-link>
        <router-link to="/about">About</router-link>
        <router-link to="/contact">Contact</router-link>
        <router-link to="/available">Store</router-link>
      </div>
    </div>
    <router-view :contact="contact" :about="about" :isMobile="isMobile"/>
    <Header v-if="this.$route.path == '/'" :isMobile="isMobile"/>
    <transition name="fade">
      <WaterLayer v-if="this.$route.path == '/about' || this.$route.path == '/contact'"/>
    </transition>
  </div>
</template>

<script>
import { EventBus } from './EventBus.js';
import WaterLayer from './views/WaterLayer.vue'
import Header from './components/Header.vue'

export default {
  name: "App",
  components: {
    WaterLayer, Header
  },
  data() {
    return {
      about: {},
      contact: {},
      gradient: {},
      url: process.env.VUE_APP_VPS_URL
    }
  },
  created() {
      this.CheckForMobile();
      window.addEventListener('resize', this.CheckForMobile);
      let selfobject = this;
      this.$http.get(selfobject.url + '/about-page')
        .then(function (response) {
        selfobject.about = response["data"];
      })
      this.$http.get(selfobject.url + '/contact-page')
      .then(function (response) {
        selfobject.contact = response["data"];
      })
      this.$http.get(selfobject.url + '/background-images')
      .then(function (response) {
        selfobject.gradient = response["data"].gradient;
        let background = document.getElementById("background");
        background.style.backgroundImage = "url('" + selfobject.url + selfobject.gradient.url + " ')";
      })

  },
  mounted() {
  },
  methods: {
      CheckForMobile() {
      let isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
      if (window.innerWidth <= 768 || isMobile) {
        EventBus.$root.mobile = true;
        this.isMobile = true;
      }
      else { 
        EventBus.$root.mobile = false;
        this.isMobile = false;
      }
    }
  }
}

</script>

<style>
@font-face {
  font-family: Sneaky;
  src: url('./assets/fonts/Sneaky-Times.otf');
}

@font-face {
  font-family: L;
  src: url('./assets/fonts/LB.ttf');
}

@font-face {
  font-family: LI;
  src: url('./assets/fonts/LI.ttf');
}

@font-face {
  font-family: Nimbus;
  src: url('./assets/fonts/NimbusRomD-Reg.otf');
}

html, body {
    width: 100%;
    height:100;
    overscroll-behavior-y: none;
}

#app {
  font-family: Sneaky, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  width: 100%;
}

#background {
  width:100%;
  height:100%;
  overflow: hidden;
  position:fixed;
  background-repeat: repeat-x;
  pointer-events: none;
}

#nav > div > a {
  font-family: L;
  font-size:20px;
  color: #ffffff;
  margin-bottom:5px;
}


a, a:active, a:hover, a:visited {
  text-decoration: underline;
  font-style:italic;
}

#nav > div > a {
  @apply flex-grow;
  font-style: initial;
}

#nav > div > a:hover {
  color: #3a6eff;
  text-decoration: none;
}

#nav > div > a.router-link-active {
  color: #3a6eff;
  font-family: LI;
}

/* FADE TRANSITION */
.fade-enter-active {
  transition: 
  /* first number is fade duration, second is waiting time */
  opacity 1s 0.2s,
  /* transform 0.5s */
}

.fade-leave-active {
  transition: 
  /* first number is fade duration, second is waiting time */
  opacity 1s 0.2s,
  /* transform 0.5s */
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  /* transform: translate(-100%, 0); */
}
</style>
